export default __webpack_public_path__ + "static/media/2-3-1.39ce5188.webp";